export class TableContextLeftOut {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "column",
            "baseName": "column",
            "type": "string",
            "format": ""
        },
        {
            "name": "why",
            "baseName": "why",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextLeftOut.attributeTypeMap;
    }
    constructor() {
    }
}
